/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) .content {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled)
}

:host([disabled]) .content *,
:host([disabled]) .content ::slotted(*) {
  pointer-events: none
}

/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-stack-padding-inline: Specifies the inline padding of the component's content.
* @prop --calcite-stack-padding-block: Specifies the block padding of the component's content.
*/
:host {
  display: flex;
  flex: 1 1 0%;
  flex-direction: column
}

.container {
  display: flex;
  flex: 1 1 auto;
  align-items: stretch;
  font-weight: var(--calcite-font-weight-normal);
  color: var(--calcite-color-text-2)
}

.content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  font-size: var(--calcite-font-size--2);
  line-height: 1.375;
  padding-inline: var(--calcite-stack-padding-inline, 0.75rem);
  padding-block: var(--calcite-stack-padding-block, 0.5rem)
}

.content-start {
  justify-content: flex-start
}

.content-end {
  justify-content: flex-end
}

.content-start,
.content-end {
  flex: 0 1 auto
}
.content-start ::slotted(calcite-icon),
.content-end ::slotted(calcite-icon) {
  margin-inline: 0.75rem;
  align-self: center
}

.actions-start,
.actions-end,
.content-start,
.content-end {
  display: flex;
  align-items: center
}

.actions-start ::slotted(calcite-action),
.actions-start ::slotted(calcite-action-menu),
.actions-start ::slotted(calcite-handle),
.actions-start ::slotted(calcite-dropdown),
.actions-end ::slotted(calcite-action),
.actions-end ::slotted(calcite-action-menu),
.actions-end ::slotted(calcite-handle),
.actions-end ::slotted(calcite-dropdown) {
  align-self: stretch;
  color: inherit
}

:host([hidden]) {
  display: none
}

[hidden] {
  display: none
}